const { nanoid } = require('nanoid');
const _ = require('lodash');


const saveState = (object, stringify = true) => {
    if (stringify)
        localStorage.state = JSON.stringify(object);
    else
        localStorage.state = object;
}

const loadState = () => {
    return JSON.parse(localStorage.state || null) || {};
}

const loadEmployees = () => {
    let e = [];
    let state = JSON.parse(localStorage.state || null) || {};
    let db = state['employees'] || [];
    for (let i=0; i<db.length; i++) {
        e.push( {
            id: db[i].id,
            name: db[i]['name'],
            qualifications: db[i]['qualifications']
        });
        console.log(db[i].id);
        console.log(db[i]['name']);
        console.log(db[i]['qualifications']);
    }
    return db;
}

const addEmployee = (name, qualifications) => {
    console.log(`Adding employee ${name} with quals: ${qualifications}`);

    let state = JSON.parse(localStorage.state || null) || [];
    let employees = state.employees || [];
    
    employees.push({
        id: nanoid(),
        name: name,
        qualifications: qualifications
    });

    localStorage.state = JSON.stringify( {...state, employees: employees} );


    // firebase.firestore().collection('employees').add( {
    //     name: name,
    //     qualifications: qualifications
    // }).then(() => {

    //     props.refreshListCb();

    // }).catch(err => {
    //     console.log(err);
    // });

}

const editEmployee = (id, name, qualifications) => {
    let state = JSON.parse(localStorage.state || null) || [];
    let employees = state.employees || [];
    
    
    let oldEntry = employees.filter( e => { return e.id == id; })[0];
    oldEntry.name = name;
    oldEntry.qualifications = qualifications;
    console.log(`editEmployee - name: ${name}, quals: ${qualifications}`)

    localStorage.state = JSON.stringify( {...state, employees: employees} );
    console.log(`localStorage - ${localStorage.state}`)

    // TODO - don't save to cloud
    // firebase.firestore().collection('employees').doc(state['editModal'].id).update( {
    //     name: state['editModal'].name,
    //     qualifications: state['editModal'].qualifications
    // }).then(() => {
    //     props.onEdit();

    // }).catch(err => {
    //     console.log(err);
    // });
}

const deleteEmployee = (id) => {
    let state = JSON.parse(localStorage.state || null) || [];
    let employees = state.employees || [];
    
    
    let newList = employees.filter( e => { return e.id !== id; });
    console.log(`deleteEmployee - id: ${id}`)

    localStorage.state = JSON.stringify( {...state, employees: newList} );

    // firebase.firestore().collection('employees').doc(props.id).delete().then(() => {
    //     props.refreshListCb();
    // }).catch(err => {
    //     console.log(err);
    // });
}



const loadPositions = () => {
    let e = [];
    let state = JSON.parse(localStorage.state || null) || {};
    let db = state['positions'] || [];
    for (let i=0; i<db.length; i++) {
        e.push( {
            id: db[i].id,
            name: db[i]['name'],
            qualifications: db[i]['qualifications'],
            timeslot: db[i]['timeslot']
        });
        console.log(db[i].id);
        console.log(db[i]['name']);
        console.log(db[i]['qualifications']);
        console.log(db[i]['timeslot']);
    }
    return db;
}

const addPosition = (name, qualifications, timeslot) => {

    let state = JSON.parse(localStorage.state || null) || [];
    let positions = state.positions || [];
    
    positions.push({
        id: nanoid(),
        name: name,
        qualifications: qualifications,
        timeslot: timeslot
    });

    localStorage.state = JSON.stringify( {...state, positions: positions} );


    // firebase.firestore().collection('positions').add( {
    //     name: name,
    //     qualifications: qualifications,
    //     timeslot: timeslot
    // }).then(() => {

    //     props.refreshListCb();

    // }).catch(err => {
    //     console.log(err);
    // });

}

const editPosition = (id, name, qualifications, timeslot) => {
    let state = JSON.parse(localStorage.state || null) || [];
    let positions = state.positions || [];
    
    
    let oldEntry = positions.filter( e => { return e.id === id; })[0];
    oldEntry.name = name;
    oldEntry.qualifications = qualifications;
    console.log(`editPosition - name: ${name}, quals: ${qualifications}, timeslot: ${timeslot}`);

    localStorage.state = JSON.stringify( {...state, positions: positions} );

    // firebase.firestore().collection('positions').doc(state['editPositionModal'].id).update( {
    //     name: state['editPositionModal'].name,
    //     qualifications: qualifications,
    //     timeslot: timeslot
    // }).then(() => {
    //     props.onEdit();

    // }).catch(err => {
    //     console.log(err);
    // });
}

const deletePosition = (id) => {
    let state = JSON.parse(localStorage.state || null) || [];
    let positions = state.positions || [];
    
    
    let newList = positions.filter( e => { return e.id !== id; });
    console.log(`deletePosition - id: ${id}`)

    localStorage.state = JSON.stringify( {...state, positions: newList} );

    // firebase.firestore().collection('positions').doc(props.id).delete().then(() => {
    //     props.refreshListCb();
    // }).catch(err => {
    //     console.log(err);
    // });
}

const loadQualifications = () => {
    let q = [];
    let state = JSON.parse(localStorage.state || null) || {};
    let db = state['qualifications'] || [];
    for (let i=0; i<db.length; i++) {
        q.push( {
            id: db[i].id,
            name: db[i]['name'],
            description: db[i]['description']
        });
        console.log(db[i].id);
        console.log(db[i]['name']);
        console.log(db[i]['description']);
    }
    return db;
}

const addQualification = (name, description) => {

    let state = JSON.parse(localStorage.state || null) || [];
    let qualifications = state.qualifications || [];
    
    let id = nanoid();

    qualifications.push({
        id: id,
        name: name,
        description: description
    });

    localStorage.state = JSON.stringify( {...state, qualifications: qualifications} );

    return id;

    // firebase.firestore().collection('qualifications').add( {
    //     name: name,
    //     description: description
    // }).then(() => {

    //     props.refreshListCb();

    // }).catch(err => {
    //     console.log(err);
    // });

}

const editQualification = (id, name, description) => {
    let state = JSON.parse(localStorage.state || null) || [];
    let qualifications = state.qualifications || [];
    
    
    let oldEntry = qualifications.filter( e => { return e.id === id; })[0];
    oldEntry.name = name;
    oldEntry.description = description;
    console.log(`editPosition - name: ${name}, description: ${description}`);

    localStorage.state = JSON.stringify( {...state, qualifications: qualifications} );

    // firebase.firestore().collection('qualifications').doc(state['editQualificationModal'].id).update( {
    //     name: state['editQualificationModal'].name,
    //     description: description,
    // }).then(() => {
    //     props.onEdit();
    
    // }).catch(err => {
    //     console.log(err);
    // });
}

const deleteQualification = (id) => {
    let state = JSON.parse(localStorage.state || null) || [];
    let qualifications = state.qualifications || [];
    
    
    let newList = qualifications.filter( e => { return e.id !== id; });
    console.log(`deleteQualification - id: ${id}`)

    localStorage.state = JSON.stringify( {...state, qualifications: newList} );

    // firebase.firestore().collection('qualifications').doc(props.id).delete().then(() => {
    //     props.refreshListCb();
    // }).catch(err => {
    //     console.log(err);
    // });
}




export { 
    saveState, 
    loadState,
    loadEmployees,
    loadPositions,
    loadQualifications,
    addEmployee,
    addPosition,
    addQualification,
    editEmployee,
    editPosition,
    editQualification,
    deleteEmployee,
    deletePosition,
    deleteQualification
}